import React from 'react'
import { FormattedNumber, FormattedMessage } from 'react-intl'
import { Box } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { ValidMaterialPricingDetailFragment } from '@src/fragments/ProductPricing.generated'
import messages from '@utils/messages'
import { useCurrentUser } from '@src/utils/useCurrentUser'
import HidePriceMessage from '@src/components/HidePriceMessage'
import { sendPricingAvailabilityInteractionEvent } from '@src/utils/analytics/pricingAndAvailability'
import { Linq } from '@src/components/Linq'
import { support } from '@src/routes'
interface MaterialPricingDisplayProps {
  material: ValidMaterialPricingDetailFragment
  listPriceClass: string
  priceClass?: string
  hasStackedPrices?: boolean
}

const useStyles = makeStyles()((theme) => ({
  pricesContainer: {
    display: 'flex',
    alignItems: 'baseline',
    '& > div:not(:first-of-type)': {
      marginLeft: theme.spacing(1),
    },
  },
  pricesStacked: {
    flexDirection: 'column',
    alignItems: 'stretch',
    '& > div:not(:first-of-type)': {
      marginLeft: theme.spacing(0),
    },
  },
  baseClass: {
    minWidth: 0,
    paddingLeft: 0,
    fontSize: theme.typography.pxToRem(16),
    fontWeight: theme.typography.fontWeightMedium,
  },
  topAligned: {
    display: 'flex',
    padding: 0,
    margin: 0,
  },
}))

const MaterialPricingDisplay: React.FC<MaterialPricingDisplayProps> = ({
  material,
  listPriceClass,
  priceClass,
  hasStackedPrices = true,
}) => {
  const { classes, cx } = useStyles()
  const { guestShoppingType, isDTAQZuCustomer } = useCurrentUser()

  let displayInquireLink
  if (material.availabilities?.length) {
    const availabilities = material.availabilities[0]
    displayInquireLink = availabilities.displayInquireLink
  }

  if (material.hidePriceMessageKey) {
    return <HidePriceMessage msgKey={material.hidePriceMessageKey} />
  }
  return displayInquireLink ? (
    <Linq
      className={cx(classes.baseClass, {
        [classes.topAligned]: displayInquireLink,
      })}
      onClick={() => {
        sendPricingAvailabilityInteractionEvent({
          action: 'inquire product',
          section: 'p&a',
          component: 'list',
          elementType: 'link',
          elementText: 'inquire',
          material: {
            materialDescription: material.materialDescription,
            brand: material.brand,
            product: material.product,
            materialNumber: material.materialNumber,
          },
        })
      }}
      href={support.customerSupportWithFormId('tfa_11')}
    >
      <FormattedMessage id="INQUIRE" defaultMessage="Inquire" />
    </Linq>
  ) : (
    <Box display="flex" alignItems="center" justifyContent="space-between">
      <div
        className={cx(classes.pricesContainer, {
          [classes.pricesStacked]: hasStackedPrices,
        })}
      >
        {/* List Price */}
        {!!material.price &&
          !!material.listPrice &&
          (material.listPrice > material.price ||
            (guestShoppingType === 'dtaq' && isDTAQZuCustomer)) && (
            <div className={listPriceClass}>
              <FormattedNumber
                style="currency"
                currencyDisplay="symbol"
                currency={
                  material.listPriceCurrency
                    ? material.listPriceCurrency
                    : material.currency
                }
                value={material.listPrice}
              />
            </div>
          )}
        {/* Price */}
        {!!material.price ? (
          <div className={priceClass}>
            <FormattedNumber
              style="currency"
              currencyDisplay="symbol"
              currency={material.currency}
              value={material.price}
            />
          </div>
        ) : (
          <FormattedMessage {...messages.UNAVAILABLE} />
        )}
      </div>
    </Box>
  )
}

export default MaterialPricingDisplay
